import { useEffect } from "react";
import { useLocation, useNavigate, useNavigationType } from "react-router-dom";
import {
  currentHistoryState,
  isOverlayClaimed,
  overlaysOf,
  withoutOverlays,
} from "../../lib/navigation/overlayHistory";

/**
 * Limpa entradas de histórico de modal que ninguém reivindica (BACKLOG §0
 * item 7, 24/09) — ver `lib/navigation/overlayHistory.ts`.
 *
 * Aparecem quando o modal fechou por NAVEGAÇÃO (a entrada ficou sob a rota
 * nova) ou quando a página recarregou numa entrada de modal. Chegar nela pelo
 * voltar mostraria a mesma página sem modal — um voltar "morto". Se nenhum
 * dono a reivindicou (`onRestore`) no tick seguinte:
 *  - chegou por POP e TODAS as marcas são órfãs → volta mais uma (a entrada
 *    de baixo é o mesmo endereço, sem modal);
 *  - senão → tira só as marcas órfãs, sem mexer na pilha.
 *
 * Mora no `AppFrame`, uma vez.
 */
export function OverlayHistoryJanitor() {
  const location = useLocation();
  const navigationType = useNavigationType();
  const navigate = useNavigate();

  useEffect(() => {
    if (overlaysOf(location.state).length === 0) return;
    const t = setTimeout(() => {
      const state = currentHistoryState();
      const marks = overlaysOf(state);
      const orphans = marks.filter((id) => !isOverlayClaimed(id));
      if (orphans.length === 0) return;
      if (orphans.length === marks.length && navigationType === "POP") {
        navigate(-1);
        return;
      }
      navigate(
        { pathname: window.location.pathname, search: window.location.search, hash: window.location.hash },
        { replace: true, state: withoutOverlays(state, orphans) },
      );
    }, 50);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- a chave da entrada é o gatilho
  }, [location.key]);

  return null;
}
